<template>
  <div class="o-wrapper o-wrapper--huge c-wrapper">
    <vue-progress-bar></vue-progress-bar>
    <router-view class="c-wrapper--min-100vh"></router-view>
    <modalSimple />
  </div>
</template>

<script>
  export default {
    name:"judge-wrapper"
  };
</script>

<style scoped>
</style>
